import styled from 'styled-components';

import { color } from '~/assets/styles/colors';

export const DivMontante = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const ImgMontante = styled.img`
	margin-right: 10px;
	filter: brightness(0);
`;

export const TextMontante = styled.div``;

export const TdExtrato = styled.td`
	justify-content: center;
	text-align: center;
`;

export const TrExtrato = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		text-align: center;
		//padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const ThExtrato = styled.th`
`;

export const TheadExtrato = styled.thead`
`;

export const TbodyExtrato = styled.tbody`
`;

